export default {
  UPDATE_CUSTOMER: 'ORDER/UPDATE_CUSTOMER',
  CREATE_NEW_PRODUCT: 'ORDER/CREATE_NEW_PRODUCT',
  CREATE_NEW_CUSTOMER: 'ORDER/CREATE_NEW_CUSTOMER',
  SELECTED_PRODUCT: 'ORDER/SELECTED_PRODUCT',
  UPDATE_ORDER: 'ORDER/UPDATE_ORDER',
  DELETE_ORDER: 'ORDER/DELETE_ORDER',
  UPDATE_CURRENT_ORDER: 'ORDER/UPDATE_CURRENT_ORDER',
  CREATE_ORDER: 'ORDER/CREATE_ORDER',
  UPDATE_HOURLY: 'ORDER/UPDATE_HOURLY'
};
